
/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  CheckLegalInformationRequest,
  ClientLegalEntityBillingInformationResource,
  ClientLegalEntityBillingInformationUpdateRequest,
  CompanyLegalInformation,
  LegalInformationProvider,
  LegalInformationSearchResponse,
  ManualLegalVerificationSource,
  SuggestedPrimaryIdentifierResource,
  ValidateRegistrationVatConsistencyRequest,
  ValidateRegistrationVatConsistencyResponse,
} from '../models';
import {
    CheckLegalInformationRequestFromJSON,
    CheckLegalInformationRequestToJSON,
    ClientLegalEntityBillingInformationResourceFromJSON,
    ClientLegalEntityBillingInformationResourceToJSON,
    ClientLegalEntityBillingInformationUpdateRequestFromJSON,
    ClientLegalEntityBillingInformationUpdateRequestToJSON,
    CompanyLegalInformationFromJSON,
    CompanyLegalInformationToJSON,
    LegalInformationProviderFromJSON,
    LegalInformationProviderToJSON,
    LegalInformationSearchResponseFromJSON,
    LegalInformationSearchResponseToJSON,
    ManualLegalVerificationSourceFromJSON,
    ManualLegalVerificationSourceToJSON,
    SuggestedPrimaryIdentifierResourceFromJSON,
    SuggestedPrimaryIdentifierResourceToJSON,
    ValidateRegistrationVatConsistencyRequestFromJSON,
    ValidateRegistrationVatConsistencyRequestToJSON,
    ValidateRegistrationVatConsistencyResponseFromJSON,
    ValidateRegistrationVatConsistencyResponseToJSON,
} from '../models';

export interface CheckLegalInformationOperationRequest {
    checkLegalInformationRequest: CheckLegalInformationRequest;
}

export interface FetchLegalInformationFromProviderRequest {
    provider: LegalInformationProvider;
    externalId: string;
    registrationNumber: string;
    countryCode: string;
    hqRegistrationCity?: string;
}

export interface GetClientLegalEntityBillingInformationRequest {
    legalEntityId: string;
}

export interface GetLegalInformationRequest {
    legalEntityId: string;
}

export interface GetLegalInformationSuggestedPrimaryIdentifierRequest {
    registrationNumber: string;
    countryCode: string;
    registrationOfficeInformation?: string;
}

export interface GetSuggestedPrimaryIdentifierRequest {
    registrationNumber: string;
    countryCode: string;
    registrationOfficeInformation?: string;
}

export interface ManuallyVerifyLegalEntityRequest {
    legalEntityId: string;
    source: ManualLegalVerificationSource;
    primaryIdentifierType: string;
    primaryIdentifierValue: string;
    url?: string | null;
    file?: Blob | null;
}

export interface SearchRequest {
    query: string;
}

export interface UpdateClientLegalEntityBillingInformationRequest {
    legalEntityId: string;
    clientLegalEntityBillingInformationUpdateRequest: ClientLegalEntityBillingInformationUpdateRequest;
}

export interface UpdateLegalInformationRequest {
    legalEntityId: string;
    clientLegalEntityBillingInformationUpdateRequest: ClientLegalEntityBillingInformationUpdateRequest;
}

export interface ValidateRegistrationVatConsistencyOperationRequest {
    validateRegistrationVatConsistencyRequest: ValidateRegistrationVatConsistencyRequest;
}

export interface VerifyLegalInformationManuallyRequest {
    legalEntityId: string;
    source: ManualLegalVerificationSource;
    primaryIdentifierType: string;
    primaryIdentifierValue: string;
    url?: string | null;
    file?: Blob | null;
}

/**
 * 
 */
export class ClientLegalEntityBillingInformationApi extends runtime.BaseAPI {

    /**
     * Check the billing information verification status
          */
    async checkLegalInformationRaw(requestParameters: CheckLegalInformationOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['checkLegalInformationRequest'] == null) {
            throw new runtime.RequiredError(
                'checkLegalInformationRequest',
                'Required parameter "checkLegalInformationRequest" was null or undefined when calling checkLegalInformation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/compliance/api/legal-information/check-legal-information`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CheckLegalInformationRequestToJSON(requestParameters['checkLegalInformationRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Check the billing information verification status
          */
    async checkLegalInformation(requestParameters: CheckLegalInformationOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.checkLegalInformationRaw(requestParameters, initOverrides);
    }

    /**
     * Fetch legal information
          */
    async fetchLegalInformationFromProviderRaw(requestParameters: FetchLegalInformationFromProviderRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<CompanyLegalInformation>> {
        if (requestParameters['provider'] == null) {
            throw new runtime.RequiredError(
                'provider',
                'Required parameter "provider" was null or undefined when calling fetchLegalInformationFromProvider().'
            );
        }

        if (requestParameters['externalId'] == null) {
            throw new runtime.RequiredError(
                'externalId',
                'Required parameter "externalId" was null or undefined when calling fetchLegalInformationFromProvider().'
            );
        }

        if (requestParameters['registrationNumber'] == null) {
            throw new runtime.RequiredError(
                'registrationNumber',
                'Required parameter "registrationNumber" was null or undefined when calling fetchLegalInformationFromProvider().'
            );
        }

        if (requestParameters['countryCode'] == null) {
            throw new runtime.RequiredError(
                'countryCode',
                'Required parameter "countryCode" was null or undefined when calling fetchLegalInformationFromProvider().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['provider'] != null) {
            queryParameters['provider'] = requestParameters['provider'];
        }

        if (requestParameters['externalId'] != null) {
            queryParameters['externalId'] = requestParameters['externalId'];
        }

        if (requestParameters['registrationNumber'] != null) {
            queryParameters['registrationNumber'] = requestParameters['registrationNumber'];
        }

        if (requestParameters['hqRegistrationCity'] != null) {
            queryParameters['hqRegistrationCity'] = requestParameters['hqRegistrationCity'];
        }

        if (requestParameters['countryCode'] != null) {
            queryParameters['countryCode'] = requestParameters['countryCode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<CompanyLegalInformation>({
            path: `/compliance/api/legal-information/fetch-client-legal-information`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=CompanyLegalInformationFromJSON(response._data); }
        return response;
    }

    /**
     * Fetch legal information
          */
    async fetchLegalInformationFromProvider(requestParameters: FetchLegalInformationFromProviderRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<CompanyLegalInformation> {
        const response = await this.fetchLegalInformationFromProviderRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     
     * @deprecated Moved to GET /compliance/api/legal-information/{legalEntityId}
     *             Replace with: getLegalInformation
     */
    async getClientLegalEntityBillingInformationRaw(requestParameters: GetClientLegalEntityBillingInformationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ClientLegalEntityBillingInformationResource>> {
        if (requestParameters['legalEntityId'] == null) {
            throw new runtime.RequiredError(
                'legalEntityId',
                'Required parameter "legalEntityId" was null or undefined when calling getClientLegalEntityBillingInformation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ClientLegalEntityBillingInformationResource>({
            path: `/compliance/api/client-company-billing-information/{legalEntityId}`.replace(`{${"legalEntityId"}}`, encodeURIComponent(String(requestParameters['legalEntityId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ClientLegalEntityBillingInformationResourceFromJSON(response._data); }
        return response;
    }

    /**
     
     * @deprecated Moved to GET /compliance/api/legal-information/{legalEntityId}
     *             Replace with: getLegalInformation
     */
    async getClientLegalEntityBillingInformation(requestParameters: GetClientLegalEntityBillingInformationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ClientLegalEntityBillingInformationResource> {
        const response = await this.getClientLegalEntityBillingInformationRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Get the billing information of a client legal entity
          */
    async getLegalInformationRaw(requestParameters: GetLegalInformationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ClientLegalEntityBillingInformationResource>> {
        if (requestParameters['legalEntityId'] == null) {
            throw new runtime.RequiredError(
                'legalEntityId',
                'Required parameter "legalEntityId" was null or undefined when calling getLegalInformation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ClientLegalEntityBillingInformationResource>({
            path: `/compliance/api/legal-information/{legalEntityId}`.replace(`{${"legalEntityId"}}`, encodeURIComponent(String(requestParameters['legalEntityId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ClientLegalEntityBillingInformationResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Get the billing information of a client legal entity
          */
    async getLegalInformation(requestParameters: GetLegalInformationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ClientLegalEntityBillingInformationResource> {
        const response = await this.getLegalInformationRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Get the suggested primary identifier type and value for manual verification
          */
    async getLegalInformationSuggestedPrimaryIdentifierRaw(requestParameters: GetLegalInformationSuggestedPrimaryIdentifierRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<SuggestedPrimaryIdentifierResource>> {
        if (requestParameters['registrationNumber'] == null) {
            throw new runtime.RequiredError(
                'registrationNumber',
                'Required parameter "registrationNumber" was null or undefined when calling getLegalInformationSuggestedPrimaryIdentifier().'
            );
        }

        if (requestParameters['countryCode'] == null) {
            throw new runtime.RequiredError(
                'countryCode',
                'Required parameter "countryCode" was null or undefined when calling getLegalInformationSuggestedPrimaryIdentifier().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['registrationNumber'] != null) {
            queryParameters['registrationNumber'] = requestParameters['registrationNumber'];
        }

        if (requestParameters['countryCode'] != null) {
            queryParameters['countryCode'] = requestParameters['countryCode'];
        }

        if (requestParameters['registrationOfficeInformation'] != null) {
            queryParameters['registrationOfficeInformation'] = requestParameters['registrationOfficeInformation'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<SuggestedPrimaryIdentifierResource>({
            path: `/compliance/api/legal-information/manual-verification/suggested-primary-identifier`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=SuggestedPrimaryIdentifierResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Get the suggested primary identifier type and value for manual verification
          */
    async getLegalInformationSuggestedPrimaryIdentifier(requestParameters: GetLegalInformationSuggestedPrimaryIdentifierRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<SuggestedPrimaryIdentifierResource> {
        const response = await this.getLegalInformationSuggestedPrimaryIdentifierRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Get the suggested primary identifier type and value for manual verification
     
     * @deprecated Moved to GET /compliance/api/legal-information/manual-verification/suggested-primary-identifier
     *             Replace with: getLegalInformationSuggestedPrimaryIdentifier
     */
    async getSuggestedPrimaryIdentifierRaw(requestParameters: GetSuggestedPrimaryIdentifierRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<SuggestedPrimaryIdentifierResource>> {
        if (requestParameters['registrationNumber'] == null) {
            throw new runtime.RequiredError(
                'registrationNumber',
                'Required parameter "registrationNumber" was null or undefined when calling getSuggestedPrimaryIdentifier().'
            );
        }

        if (requestParameters['countryCode'] == null) {
            throw new runtime.RequiredError(
                'countryCode',
                'Required parameter "countryCode" was null or undefined when calling getSuggestedPrimaryIdentifier().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['registrationNumber'] != null) {
            queryParameters['registrationNumber'] = requestParameters['registrationNumber'];
        }

        if (requestParameters['countryCode'] != null) {
            queryParameters['countryCode'] = requestParameters['countryCode'];
        }

        if (requestParameters['registrationOfficeInformation'] != null) {
            queryParameters['registrationOfficeInformation'] = requestParameters['registrationOfficeInformation'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<SuggestedPrimaryIdentifierResource>({
            path: `/compliance/api/client-company-billing-information/manual-verification/suggested-primary-identifier`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=SuggestedPrimaryIdentifierResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Get the suggested primary identifier type and value for manual verification
     
     * @deprecated Moved to GET /compliance/api/legal-information/manual-verification/suggested-primary-identifier
     *             Replace with: getLegalInformationSuggestedPrimaryIdentifier
     */
    async getSuggestedPrimaryIdentifier(requestParameters: GetSuggestedPrimaryIdentifierRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<SuggestedPrimaryIdentifierResource> {
        const response = await this.getSuggestedPrimaryIdentifierRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Manually verify a client legal entity
     
     * @deprecated Moved to POST /compliance/api/legal-information/{legalEntityId}/manual-verification
     *             Replace with: verifyLegalInformationManually
     */
    async manuallyVerifyLegalEntityRaw(requestParameters: ManuallyVerifyLegalEntityRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['legalEntityId'] == null) {
            throw new runtime.RequiredError(
                'legalEntityId',
                'Required parameter "legalEntityId" was null or undefined when calling manuallyVerifyLegalEntity().'
            );
        }

        if (requestParameters['source'] == null) {
            throw new runtime.RequiredError(
                'source',
                'Required parameter "source" was null or undefined when calling manuallyVerifyLegalEntity().'
            );
        }

        if (requestParameters['primaryIdentifierType'] == null) {
            throw new runtime.RequiredError(
                'primaryIdentifierType',
                'Required parameter "primaryIdentifierType" was null or undefined when calling manuallyVerifyLegalEntity().'
            );
        }

        if (requestParameters['primaryIdentifierValue'] == null) {
            throw new runtime.RequiredError(
                'primaryIdentifierValue',
                'Required parameter "primaryIdentifierValue" was null or undefined when calling manuallyVerifyLegalEntity().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['source'] != null) {
            formParams.append('source', new Blob([JSON.stringify(ManualLegalVerificationSourceToJSON(requestParameters['source']))], { type: "application/json", }));
                    }

        if (requestParameters['url'] != null) {
            formParams.append('url', requestParameters['url'] as any);
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }

        if (requestParameters['primaryIdentifierType'] != null) {
            formParams.append('primaryIdentifierType', requestParameters['primaryIdentifierType'] as any);
        }

        if (requestParameters['primaryIdentifierValue'] != null) {
            formParams.append('primaryIdentifierValue', requestParameters['primaryIdentifierValue'] as any);
        }

        const response = await this.request<void>({
            path: `/compliance/api/client-company-billing-information/{legalEntityId}/manual-verification`.replace(`{${"legalEntityId"}}`, encodeURIComponent(String(requestParameters['legalEntityId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return response;
    }

    /**
     * Manually verify a client legal entity
     
     * @deprecated Moved to POST /compliance/api/legal-information/{legalEntityId}/manual-verification
     *             Replace with: verifyLegalInformationManually
     */
    async manuallyVerifyLegalEntity(requestParameters: ManuallyVerifyLegalEntityRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.manuallyVerifyLegalEntityRaw(requestParameters, initOverrides);
    }

    /**
     * Search for company legal information
          */
    async searchRaw(requestParameters: SearchRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<LegalInformationSearchResponse>>> {
        if (requestParameters['query'] == null) {
            throw new runtime.RequiredError(
                'query',
                'Required parameter "query" was null or undefined when calling search().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<LegalInformationSearchResponse>>({
            path: `/compliance/api/legal-information/search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(LegalInformationSearchResponseFromJSON);
        return response;
    }

    /**
     * Search for company legal information
          */
    async search(requestParameters: SearchRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<LegalInformationSearchResponse>> {
        const response = await this.searchRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     
     * @deprecated Moved to POST /compliance/api/legal-information/{legalEntityId}
     *             Replace with: updateLegalInformation
     */
    async updateClientLegalEntityBillingInformationRaw(requestParameters: UpdateClientLegalEntityBillingInformationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ClientLegalEntityBillingInformationResource>> {
        if (requestParameters['legalEntityId'] == null) {
            throw new runtime.RequiredError(
                'legalEntityId',
                'Required parameter "legalEntityId" was null or undefined when calling updateClientLegalEntityBillingInformation().'
            );
        }

        if (requestParameters['clientLegalEntityBillingInformationUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'clientLegalEntityBillingInformationUpdateRequest',
                'Required parameter "clientLegalEntityBillingInformationUpdateRequest" was null or undefined when calling updateClientLegalEntityBillingInformation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<ClientLegalEntityBillingInformationResource>({
            path: `/compliance/api/client-company-billing-information/{legalEntityId}`.replace(`{${"legalEntityId"}}`, encodeURIComponent(String(requestParameters['legalEntityId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ClientLegalEntityBillingInformationUpdateRequestToJSON(requestParameters['clientLegalEntityBillingInformationUpdateRequest']),
        }, initOverrides);

        if (response._data) { response._data=ClientLegalEntityBillingInformationResourceFromJSON(response._data); }
        return response;
    }

    /**
     
     * @deprecated Moved to POST /compliance/api/legal-information/{legalEntityId}
     *             Replace with: updateLegalInformation
     */
    async updateClientLegalEntityBillingInformation(requestParameters: UpdateClientLegalEntityBillingInformationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ClientLegalEntityBillingInformationResource> {
        const response = await this.updateClientLegalEntityBillingInformationRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Update the billing information of a client legal entity
          */
    async updateLegalInformationRaw(requestParameters: UpdateLegalInformationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ClientLegalEntityBillingInformationResource>> {
        if (requestParameters['legalEntityId'] == null) {
            throw new runtime.RequiredError(
                'legalEntityId',
                'Required parameter "legalEntityId" was null or undefined when calling updateLegalInformation().'
            );
        }

        if (requestParameters['clientLegalEntityBillingInformationUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'clientLegalEntityBillingInformationUpdateRequest',
                'Required parameter "clientLegalEntityBillingInformationUpdateRequest" was null or undefined when calling updateLegalInformation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<ClientLegalEntityBillingInformationResource>({
            path: `/compliance/api/legal-information/{legalEntityId}`.replace(`{${"legalEntityId"}}`, encodeURIComponent(String(requestParameters['legalEntityId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ClientLegalEntityBillingInformationUpdateRequestToJSON(requestParameters['clientLegalEntityBillingInformationUpdateRequest']),
        }, initOverrides);

        if (response._data) { response._data=ClientLegalEntityBillingInformationResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Update the billing information of a client legal entity
          */
    async updateLegalInformation(requestParameters: UpdateLegalInformationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ClientLegalEntityBillingInformationResource> {
        const response = await this.updateLegalInformationRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Validate that a registration number and VAT number belong to the same company
          */
    async validateRegistrationVatConsistencyRaw(requestParameters: ValidateRegistrationVatConsistencyOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ValidateRegistrationVatConsistencyResponse>> {
        if (requestParameters['validateRegistrationVatConsistencyRequest'] == null) {
            throw new runtime.RequiredError(
                'validateRegistrationVatConsistencyRequest',
                'Required parameter "validateRegistrationVatConsistencyRequest" was null or undefined when calling validateRegistrationVatConsistency().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<ValidateRegistrationVatConsistencyResponse>({
            path: `/compliance/api/legal-information/validate-reg-vat-consistency`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ValidateRegistrationVatConsistencyRequestToJSON(requestParameters['validateRegistrationVatConsistencyRequest']),
        }, initOverrides);

        if (response._data) { response._data=ValidateRegistrationVatConsistencyResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Validate that a registration number and VAT number belong to the same company
          */
    async validateRegistrationVatConsistency(requestParameters: ValidateRegistrationVatConsistencyOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ValidateRegistrationVatConsistencyResponse> {
        const response = await this.validateRegistrationVatConsistencyRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Manually verify a client legal entity
          */
    async verifyLegalInformationManuallyRaw(requestParameters: VerifyLegalInformationManuallyRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['legalEntityId'] == null) {
            throw new runtime.RequiredError(
                'legalEntityId',
                'Required parameter "legalEntityId" was null or undefined when calling verifyLegalInformationManually().'
            );
        }

        if (requestParameters['source'] == null) {
            throw new runtime.RequiredError(
                'source',
                'Required parameter "source" was null or undefined when calling verifyLegalInformationManually().'
            );
        }

        if (requestParameters['primaryIdentifierType'] == null) {
            throw new runtime.RequiredError(
                'primaryIdentifierType',
                'Required parameter "primaryIdentifierType" was null or undefined when calling verifyLegalInformationManually().'
            );
        }

        if (requestParameters['primaryIdentifierValue'] == null) {
            throw new runtime.RequiredError(
                'primaryIdentifierValue',
                'Required parameter "primaryIdentifierValue" was null or undefined when calling verifyLegalInformationManually().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['source'] != null) {
            formParams.append('source', new Blob([JSON.stringify(ManualLegalVerificationSourceToJSON(requestParameters['source']))], { type: "application/json", }));
                    }

        if (requestParameters['url'] != null) {
            formParams.append('url', requestParameters['url'] as any);
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }

        if (requestParameters['primaryIdentifierType'] != null) {
            formParams.append('primaryIdentifierType', requestParameters['primaryIdentifierType'] as any);
        }

        if (requestParameters['primaryIdentifierValue'] != null) {
            formParams.append('primaryIdentifierValue', requestParameters['primaryIdentifierValue'] as any);
        }

        const response = await this.request<void>({
            path: `/compliance/api/legal-information/{legalEntityId}/manual-verification`.replace(`{${"legalEntityId"}}`, encodeURIComponent(String(requestParameters['legalEntityId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return response;
    }

    /**
     * Manually verify a client legal entity
          */
    async verifyLegalInformationManually(requestParameters: VerifyLegalInformationManuallyRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.verifyLegalInformationManuallyRaw(requestParameters, initOverrides);
    }

}
